import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { EligibleTrainingItemsVM } from "@academy-context/shared/domain/types/eligible-training-items";

export const adminRetrieveEligibleTrainingItems = createAsyncThunk<EligibleTrainingItemsVM, string, { extra: Partial<Dependencies> }>(
  "admin/retrieveEligibleTrainingItems",
  async (studentId: string, { extra: { adminRepository } }) => {
    return adminRepository!.getEligibleTrainingItems(studentId);
  },
);
